import { Button, Form, message, Input, Col, Row } from 'antd';
import AppHeader from 'components/AppHeader';
import React, { useState, useEffect } from 'react';
import affiliateApis from 'api/affiliateApis';
import { ContentRow } from 'components/ThemeComponents';
import { StyledTable, OFFSET_HEADER } from 'components/ThemeComponents';
import { fullDateTimeFormat, onlyDateFormat } from 'helpers/dateTimeHelper';

export default function ListCommissionAffiliatesPage() {

  const [affiliates, setAffiliates] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [paginate, setPaginate] = useState({})
  const [searchForm] = Form.useForm();

  async function fetchAffiliates(params={}) {
    setIsFetching(true);
    try {
      const new_params = Object.assign({}, params, {affiliate_type: 'commission'})
      const res = await affiliateApis.listing(new_params);
      if (res.code === 200) {
        setAffiliates(res.data ?? []);
        setPaginate({page: res.page, limit: res.limit, total: res.total})
      }
    } catch (error) {
      message.info(error.message);
    }
    setIsFetching(false);
  }

  useEffect(() => {
    fetchAffiliates()
  }, []);

  const onChangeTable = async(pagination, filters, sorter) => {
    console.log(sorter)
    var params = {
      page: pagination.current,
      limit: pagination.pageSize,
      data_sort: sorter.columnKey,
      order_sort: sorter.order
    }
    const args = Object.assign({}, params, searchForm.getFieldsValue())
    await fetchAffiliates(args)
  }

  const onFinishSearchForm = async (values) => {
    const params = values || {}
    console.log(params)
    await fetchAffiliates(params)
  };

  const bottom = 'bottomRight';

  const columns = [
    {
      title: 'ID',
      width: '15rem',
      render: (record) => <span>{record.id}</span>
    },
    {
      title: 'tenant_id',
      width: '15rem',
      render: (record) => <span>{record.tenant_id}</span>
    },
    {
      title: 'store domain',
      width: '12rem',
      ellipsis: {
        showTitle: false
      },
      render: (record) => <span>{record.store_domain}</span>
    },
    {
      title: 'email owner',
      width: '15rem',
      ellipsis: {
        showTitle: false
      },
      render: (record) => <span>{record.email_owner}</span>
    },
    {
      title: 'order_payment_id',
      width: '10rem',
      render: (record) => <span>{record.order_payment_id}</span>
    },
    {
      title: 'status',
      width: '10rem',
      ellipsis: {
        showTitle: false
      },
      render: (record) => <span>{record.status}</span>
    },
    {
      title: 'note',
      width: '10rem',
      render: (record) => <span>{record.note}</span>
    },
    {
      title: 'commission_amount',
      width: '10rem',
      ellipsis: {
        showTitle: false
      },
      render: (record) => <span>{record.commission_amount}</span>
    },
    {
      title: 'created_at',
      width: '10rem',
      key: 'created_at',
      sorter: true,
      ellipsis: {
        showTitle: false
      },
      render: (record) => <span>{fullDateTimeFormat(record.created_at)}</span>
    },
    {
      title: 'updated_at',
      width: '10rem',
      ellipsis: {
        showTitle: false
      },
      render: (record) => <span>{fullDateTimeFormat(record.updated_at)}</span>
    }
  ];
  
  return (
    <>
      <AppHeader
        fixedTop
        pageTitle="Tất cả commission affiliates"
        pageHeaderExtras={
          <>
            <Button type="primary">
              Thêm
            </Button>
          </>
        }
      />
      <br />
      <ContentRow capped>
      <Form
          form={searchForm}
          name="advanced_search"
          className="ant-advanced-search-form"
          onFinish={onFinishSearchForm}
          style={{marginBottom: "40px"}}
        >
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item
                name='tenant_id'
                label='tenant_id'
              >
                <Input placeholder="Tìm theo tenant_id" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name='order_payment_id'
                label='order_payment_id'
              >
                <Input placeholder="Tìm theo order_payment_id" />
              </Form.Item>
            </Col>
            <Col
              style={{
                textAlign: 'right',
              }}
            >
              <Button type="primary" htmlType="submit">
                Search
              </Button>
              <Button
                style={{
                  margin: '0 8px',
                }}
                onClick={() => {
                  searchForm.resetFields();
                  onFinishSearchForm();
                }}
              >
                Clear
              </Button>
            </Col>
          </Row>
        </Form>
        <StyledTable
          sticky={{ offsetHeader: OFFSET_HEADER }}
          size="small"
          scroll={{ x: 1000 }}
          loading={isFetching}
          rowKey="id"
          // @ts-ignore
          columns={columns}
          dataSource={affiliates}
          onChange={onChangeTable}
          pagination={{
            defaultPageSize: paginate.limit,
            defaultCurrent: paginate.page,
            total: paginate.total,
            position: [bottom],
            showTotal: (total, range) => (
              <span style={{ left: 0, position: 'absolute' }}>
                Hiển thị {range[0]}-{range[1]} của {total} tin đã đăng
              </span>
            )
          }}
        />
      </ContentRow>
    </>
  );
}

